// Generated file : do not modify
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Formes Juridiques
export default class FormeJuridique  {
  // Identifiant unique
  public id: number;
  // code INSEE
  public code: string;
  // Libellé
  public nom: string;
  // Réduction générale
  public reduction: boolean;
  // Activite 98
  public activite98: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.nom = '';
    this.reduction = false;
    this.activite98 = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: FormeJuridique): FormeJuridique {
    const newFormeJuridique: FormeJuridique = new FormeJuridique();
    newFormeJuridique.id = obj.id;
    newFormeJuridique.code = obj.code;
    newFormeJuridique.nom = obj.nom;
    newFormeJuridique.reduction = obj.reduction;
    newFormeJuridique.activite98 = obj.activite98;
    newFormeJuridique.canUpdate = obj.canUpdate;
    newFormeJuridique.canDelete = obj.canDelete;
    newFormeJuridique.display = obj.display;
    newFormeJuridique.notifDefType = obj.notifDefType;
    return newFormeJuridique;
  }

  public toJsonFormeJuridique (): string {
    const json = {
      code: this.code,
      nom: this.nom,
      reduction: this.reduction,
      activite98: this.activite98,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromFormeJuridique (obj: FormeJuridique): void {
    this.id = obj.id;
    this.code = obj.code;
    this.nom = obj.nom;
    this.reduction = obj.reduction;
    this.activite98 = obj.activite98;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareFormeJuridique (value: FormeJuridique): boolean {
    return (this.toJsonFormeJuridique() == value.toJsonFormeJuridique());
  }

  public cloneFormeJuridique (): FormeJuridique {
    return FormeJuridique.fromJson(this);
  }

  public create (): Promise<FormeJuridique> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/formejuridiques/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromFormeJuridique(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<FormeJuridique> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/formejuridiques/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromFormeJuridique(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/formejuridiques/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/formejuridiques/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<FormeJuridique> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/FormeJuridiques/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = FormeJuridique.fromJson(listData.reccords[0] as FormeJuridique);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(formeJuridiques: FormeJuridique[]) {
  }
}
